import Vue from 'vue';
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const guaxinimWebResources =
  require("properties-loader!guaxinim-web/src/i18n/GuaxinimWebResources.properties");
const pandaResources =
  require("properties-loader!../../../panda-backend/src/main/resources/br/net/a7/panda/PandaResources.properties");

const i18n = new VueI18n({
  locale: 'pt-BR',
  messages: {
    'pt-BR': {
      ...guaxinimWebResources,
      ...pandaResources
    }
  }
});

export default i18n;